<template>
    <confirmation-popup
        ref="popup"
        v-bind:title="resource('DmVisualizer_ScenarioSelectionConfirmationPopup_Title')"
        v-bind:texts="texts"
    >
        <button
                class="btn btn-primary"
                @click="$emit('confirm')"
        >
            {{resource('DmVisualizer_ScenarioSelectionConfirmationPopup_ConfirmationButtonText')}}
        </button>
    </confirmation-popup>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources'
    
    import ConfirmationPopup from "./../ConfirmationPopup.vue";
    
    export default {
        name: "scenario-selection-confirmation-popup",
        mixins: [resourceMixin],
        components: {ConfirmationPopup},
        methods: {
            show(){
                this.$refs.popup.show();
            }
        },
        computed: {
            texts(){
                return this.scenarios.map(scenario => ({
                    header: scenario.confirmationTextHeader,
                    body: scenario.confirmationText
                }));
            }
        },
        props: {
            scenarios: {
                type: Array,
                required: true,
                default: () => ({
                    id: '',
                    confirmationTextHeader: '',
                    confirmationText: ''
                })
            }
        }
    }
</script>
